
// import video from '../assets/video/example.mp4'
import video from '../assets/video/video.mov'

export default function Video() {
  return (
    <video className="absolute inset-0 h-full w-full object-cover" 
      autoPlay 
      muted 
      playsInline
      preload="auto"
      >
      <source src={video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>

  );
}
